module.exports = __webpack_public_path__ + "static/img/report-default-cover.778c436.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/report-default-cover.jpeg
// module id = hp+x
// module chunks = 3